



























































































































import Vue from 'vue';
import Component from 'vue-class-component';
import {Prop} from 'vue-property-decorator';
import AmetrasTextFieldTemplate from '@/fields/text/AmetrasTextFieldTemplate.vue';
import AmetrasSelectFieldTemplate from '@/fields/select/AmetrasSelectFieldTemplate.vue';
import '@/compiled-icons/format-align-center';
import '@/compiled-icons/format-align-left';
import '@/compiled-icons/format-align-right';
import '@/compiled-icons/toy-brick-plus-outline';
import AmetrasCheckBoxTemplate from '@/fields/checkbox/AmetrasCheckBoxTemplate.vue';
import AmetrasNumberFieldTemplate from '@/fields/text/AmetrasNumberFieldTemplate.vue';

import '@/compiled-icons/add';
import AmetrasTextAreaFieldTemplate from '@/fields/text-area/AmetrasTextAreaFieldTemplate.vue';
import AmetrasDateFieldTemplate from '@/fields/date/AmetrasDateFieldTemplate.vue';
import AmetrasHexColorPickerTemplate from '@/fields/hex-color-picker/AmetrasHexColorPickerTemplate.vue';
import DynamicDocumentFontConfigurationTemplate from '@/views/dynamicdocuments/fields/dynamic-document-font-configuration-template.vue';
import AmetrasMonthFieldTemplate from '@/fields/date/AmetrasMonthFieldTemplate.vue';

@Component({
  name: 'dynamic-document-text-brick-template',
  components: {
    AmetrasMonthFieldTemplate,
    DynamicDocumentFontConfigurationTemplate,
    AmetrasHexColorPickerTemplate,
    AmetrasDateFieldTemplate,
    AmetrasTextAreaFieldTemplate,
    AmetrasNumberFieldTemplate,
    AmetrasCheckBoxTemplate,
    AmetrasTextFieldTemplate,
    AmetrasSelectFieldTemplate
  }
})
export default class DynamicDocumentNumberFieldTemplate extends Vue {

  @Prop({required: true}) fieldConfig: DisguiseDto.DynamicDocumentFieldTypeNumberDtoV2 | undefined;
  @Prop({required: false}) contextSelectValues: DisguiseDto.SelectDto[] | undefined;

}
